import * as React from 'react'
import Box from '@mui/material/Box'

type Props = {
  blueBackground?: boolean
  children: React.ReactNode
}

export function Section(props: Props) {
  const { blueBackground, children } = props

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="50%"
      height="100%"
      overflow="hidden"
      p={1.5}
      style={
        blueBackground ? { backgroundColor: 'rgba(248, 251, 255)' } : undefined
      }
    >
      {children}
    </Box>
  )
}
